/**
 * Address autocomplete data access (issue #23).
 *
 * Proxies Google Places Autocomplete through the Go service
 * (GET /api/admin/places/autocomplete) — the Maps key is IP-restricted, so the
 * SPA never calls Google directly. A 503 (geo unwired) surfaces as an empty
 * list so the warehouse field degrades to a plain text input.
 */
import { apiFetch } from "../../../shared/api-client";

export interface AddressSuggestion {
  description: string;
}

export async function autocompleteAddress(
  query: string,
  signal?: AbortSignal,
): Promise<AddressSuggestion[]> {
  const res = await apiFetch<{ suggestions: AddressSuggestion[] }>(
    "/api/admin/places/autocomplete",
    { query: { q: query }, signal },
  );
  return res.suggestions ?? [];
}
